import cx from 'classnames';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  error?: boolean;
  theme?: LabelTheme;
  className?: string;
}

export enum LabelTheme {
  DEFAULT,
  PINK,
}

const THEME_TO_CLASSES = {
  [LabelTheme.DEFAULT]: 'text-gray-700',
  [LabelTheme.PINK]: 'text-pink-500 font-bold',
};

export function Label({
  error,
  children,
  theme = LabelTheme.DEFAULT,
  className,
}: IProps) {
  let textClass = THEME_TO_CLASSES[theme];

  if (error) {
    textClass = 'text-red-500';
  }

  return (
    <label className={cx('block font-ubuntu text-14', textClass, className)}>
      {children}
    </label>
  );
}

Label.Pink = (props: IProps) => <Label {...props} theme={LabelTheme.PINK} />;
